import getNoteLength from "./getNoteLength";

import { unitDist } from "../parameters";
import { IBeaming, INote, ISpaces } from "../../../../../common/types";

const getBeamWidth = (notes: INote[], spaces: ISpaces, endPosition: number, beaming: IBeaming, barNoteIndex: number, type: number, noteDistance = 1) => {
    const totalBeamed = beaming[type === 8 ? "totalBeamed8" : "totalBeamed16"]!;
    let startPosition = endPosition;
    for (let n = barNoteIndex - 1; n > barNoteIndex - totalBeamed - 1; n--) {
        startPosition -= getNoteLength(notes[n]);
    }
    let width = ((endPosition - startPosition) / 3) * unitDist * noteDistance;
    width += Object.keys(spaces)
        .map(pos => {
            if (+pos < startPosition) return 0;
            if (+pos >= endPosition) return 0;
            return spaces[pos];
        })
        .reduce((a, b) => a + b, 0);
    return width;
};

export default getBeamWidth;
